import * as React from 'react';

import {
  Props,
} from 'one-ui';

export interface BoxBodyProps extends Props {
}

export const BoxBody = ({
  children,
}: BoxBodyProps) => (
    <div className="box__main">
      {children}
    </div>
  );
